import type { DriveStep } from 'driver.js';

function el(selector: string): Element {
  return (document.querySelector(selector) as Element) ?? document.body;
}

/**
 * Pure step list for the team performance dashboard walkthrough.
 * Element resolvers run when each step is shown.
 */
export function buildTeamDashboardWalkthroughSteps(): DriveStep[] {
  return [
    {
      element: () => el('[data-tour="team-intro"]'),
      popover: {
        title: 'Team performance',
        description:
          'See practice results across everyone in your organization. This view is for coaching and analytics — it does not include settings or billing.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: () => el('[data-tour="team-period"]'),
      popover: {
        title: 'Time range',
        description:
          'Filter the snapshot by the last 7, 30, or 90 days, or show all time. The same range applies to the member table.',
        side: 'bottom',
        align: 'end',
      },
    },
    {
      element: () => el('[data-tour="team-kpis"]'),
      popover: {
        title: 'Organization snapshot',
        description:
          'Sessions, completed runs, average goal score, goal reach rate, and total practice time for the selected period.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: () => el('[data-tour="team-members"]'),
      popover: {
        title: 'Members',
        description:
          'Sort the table to compare people. Click a name to open their sessions, then open a session to review the full practice.',
        side: 'top',
        align: 'start',
      },
    },
  ];
}
